/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_Read_Error_ToastInputs */

const en_plain_text_import_read_error_toast = /** @type {(inputs: Plain_Text_Import_Read_Error_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error reading file`)
};

const fr_plain_text_import_read_error_toast = /** @type {(inputs: Plain_Text_Import_Read_Error_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur de lecture du fichier`)
};

const de_plain_text_import_read_error_toast = /** @type {(inputs: Plain_Text_Import_Read_Error_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Lesen der Datei`)
};

const it_plain_text_import_read_error_toast = /** @type {(inputs: Plain_Text_Import_Read_Error_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errore durante la lettura del file`)
};

const ru_plain_text_import_read_error_toast = /** @type {(inputs: Plain_Text_Import_Read_Error_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ошибка при чтении файла`)
};

const es_plain_text_import_read_error_toast = /** @type {(inputs: Plain_Text_Import_Read_Error_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al leer el archivo`)
};

const zh_cn2_plain_text_import_read_error_toast = /** @type {(inputs: Plain_Text_Import_Read_Error_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`读取文件时出错`)
};

const ja_plain_text_import_read_error_toast = /** @type {(inputs: Plain_Text_Import_Read_Error_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイルの読み取りエラー`)
};

const hi_plain_text_import_read_error_toast = /** @type {(inputs: Plain_Text_Import_Read_Error_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ाइल पढ़ने में त्रुटि`)
};

const pt_pt2_plain_text_import_read_error_toast = /** @type {(inputs: Plain_Text_Import_Read_Error_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erro ao ler o arquivo`)
};

/**
* | output |
* | --- |
* | "Error reading file" |
*
* @param {Plain_Text_Import_Read_Error_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_read_error_toast = /** @type {((inputs?: Plain_Text_Import_Read_Error_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_Read_Error_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_plain_text_import_read_error_toast(inputs)
	if (locale === "de") return de_plain_text_import_read_error_toast(inputs)
	if (locale === "it") return it_plain_text_import_read_error_toast(inputs)
	if (locale === "ru") return ru_plain_text_import_read_error_toast(inputs)
	if (locale === "es") return es_plain_text_import_read_error_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_plain_text_import_read_error_toast(inputs)
	if (locale === "ja") return ja_plain_text_import_read_error_toast(inputs)
	if (locale === "hi") return hi_plain_text_import_read_error_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_plain_text_import_read_error_toast(inputs)
	return en_plain_text_import_read_error_toast(inputs)
});